/**
 * Copyright (c) 2024 The Diffusion Studio Authors
 *
 * This Source Code Form is subject to the terms of the Mozilla 
 * Public License, v. 2.0 that can be found in the LICENSE file.
 */

import { Track, TrackMap } from '..';

export class TrackDeserializer {
	public static fromType<T extends keyof TrackMap>(data: { type: T; id?: string }): TrackMap[T] {
		switch (data.type) {
			// case 'video':
			// 	return new VideoTrack(data.id) as TrackMap[T];
			// case 'audio':
			// 	return new AudioTrack(data.id) as TrackMap[T];
			// case 'html':
			// 	return new HtmlTrack(data.id) as TrackMap[T];
			// case 'image':
			// 	return new ImageTrack(data.id) as TrackMap[T];
			// case 'text':
			// 	return new TextTrack(data.id) as TrackMap[T];
			// case 'complex_text':
			// 	return new TextTrack(data.id) as TrackMap[T];
			// case 'caption':
			// 	return new CaptionTrack(data.id) as TrackMap[T];
			default:
				return new Track(data.id) as TrackMap[T];
		}
	}
}
